import { render, staticRenderFns } from "./FeedManagerHeader.vue?vue&type=template&id=1c1134c8&scoped=true&"
import script from "./FeedManagerHeader.vue?vue&type=script&lang=js&"
export * from "./FeedManagerHeader.vue?vue&type=script&lang=js&"
import style0 from "./FeedManagerHeader.vue?vue&type=style&index=0&id=1c1134c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1134c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/harness/feed-manager-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1134c8')) {
      api.createRecord('1c1134c8', component.options)
    } else {
      api.reload('1c1134c8', component.options)
    }
    module.hot.accept("./FeedManagerHeader.vue?vue&type=template&id=1c1134c8&scoped=true&", function () {
      api.rerender('1c1134c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeedManagerHeader.vue"
export default component.exports